<template>
  <div class="p-6">
    <h2 class="mb-4">Enums Manager</h2>

    <div class="flex items-center mb-4">
      <Button label="Create New Enum" icon="pi pi-plus" @click="openCreate" />
      <ProgressSpinner v-if="loading" class="ml-2" />
    </div>
    <div v-if="error" class="mb-4 text-red-600"><strong>Error:</strong> {{ error }}</div>

    <div v-if="!enumTypes.length" class="text-gray-500">No enums available.</div>
    <div v-else class="space-y-4">
      <EnumType
        v-for="e in enumTypes"
        :key="e._id"
        :enumType="e"
        @edit-enum="openEdit"
        @delete-enum="handleDeleteEnum"
      />
    </div>

    <!-- Dialogs -->
    <Dialog header="Create New Enum" v-model:visible="createDialog" modal>
      <NewEnumDialog v-model:visible="createDialog" />
    </Dialog>
    <Dialog
      v-if="editDialog && editingEnum"
      :header="`Edit Enum: ${editingEnum.name}`"
      v-model:visible="editDialog"
      modal
    >
      <EditEnumDialog v-model:visible="editDialog" :enumData="editingEnum" />
    </Dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';
import EnumType from '../components/EnumType.vue';
import NewEnumDialog from '../components/NewEnumDialog.vue';
import EditEnumDialog from '../components/EditEnumDialog.vue';

export default {
  name: 'EnumsManager',
  components: {
    Dialog,
    Button,
    ProgressSpinner,
    EnumType,
    NewEnumDialog,
    EditEnumDialog,
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editingEnum: null,
    };
  },
  computed: {
    ...mapState('enums', {
      enumTypes: (state) => state.enumTypes,
      loading: (state) => state.loading,
      error: (state) => state.error,
    }),
  },
  watch: {
    enumTypes: {
      deep: true,
      handler() {
        if (!this.editDialog || !this.editingEnum?.name) return;
        const fresh = this.enumTypes.find((e) => e.name === this.editingEnum.name);
        if (fresh) this.editingEnum = fresh;
      },
    },
  },
  mounted() {
    this.clearError();
    this.fetchEnumTypes();
  },
  methods: {
    ...mapActions('enums', ['fetchEnumTypes', 'deleteEnumType', 'clearError']),
    openCreate() {
      this.createDialog = true;
    },
    closeCreateDialog() {
      this.createDialog = false;
    },
    openEdit(enumObj) {
      this.clearError();
      // Prefer latest copy from store (keeps dialog in sync after activate/deactivate refetch)
      this.editingEnum =
        this.enumTypes.find((e) => e._id === enumObj._id || e.name === enumObj.name) || enumObj;
      this.editDialog = true;
    },
    async handleDeleteEnum(enumObj) {
      try {
        const shouldDelete = await new Promise((resolve) => {
          this.$confirm.require({
            message: `Delete enum "${enumObj.name}" and all its values? This cannot be undone.`,
            header: 'Delete enum',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Delete',
            rejectLabel: 'Cancel',
            acceptClass: 'p-button-danger',
            accept: () => resolve(true),
            reject: () => resolve(false),
          });
        });
        if (!shouldDelete) return;
        await this.deleteEnumType(enumObj.name);
      } catch (e) {
        // error in store.error
      }
    },
  },
};
</script>

<style scoped></style>
